exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".articleRating td{padding:0 10px 0 10px}.text-right a{margin:20px 15px 0 0}", ""]);

